module.exports = {
    'shop': 'shop/products',
    'shop.order.summary': '/shop/order/summary/$1',
    'shop.order.update': '/shop/subscription/$1',
    'shop.order.remove': '/shop/subscription/$1/product/$2',
    'shop.next-delivery': '/shop/subscription/delivery/$1',
};
